// // src/admindashboardutils/utils/timeUtils.js
// export const parseTimeToSeconds = (timeStr) => {
//     if (!timeStr) return 0;
//     const [time, period] = timeStr.trim().split(" ");
//     let [hours, minutes, seconds] = time.split(":").map(Number);
  
//     if (isNaN(hours) || isNaN(minutes) || isNaN(seconds)) {
//       console.error("Invalid time format:", timeStr);
//       return 0;
//     }
  
//     if (period.toLowerCase() === "pm" && hours !== 12) hours += 12;
//     if (period.toLowerCase() === "am" && hours === 12) hours = 0;
  
//     return hours * 3600 + minutes * 60 + seconds;
//   };
  
//   export const calculateCallDuration = (startTime, endTime) => {
//     const startSeconds = parseTimeToSeconds(startTime);
//     const endSeconds = parseTimeToSeconds(endTime);
  
//     let duration = endSeconds - startSeconds;
//     if (duration < 0) {
//       duration += 24 * 3600; // Add 24 hours if endTime is on the next day
//     } else if (duration > 24 * 3600) {
//       console.warn("Duration exceeds 24 hours, clamping to 24 hours:", duration);
//       duration = 24 * 3600;
//     }
  
//     return duration;
//   };
  
//   export const isToday = (dateStr) => {
//     if (!dateStr) {
//       console.warn("Missing createdAt field for call, skipping...");
//       return false;
//     }
//     const callDate = new Date(dateStr);
//     const today = new Date();
//     return (
//       callDate.getDate() === today.getDate() &&
//       callDate.getMonth() === today.getMonth() &&
//       callDate.getFullYear() === today.getFullYear()
//     );
//   };
  
//   export const getFullDayName = (date) => {
//     const days = ["Sun", "Mon", "Tue", "Wed", "Thurs", "Fri", "Sat"];
//     return days[date.getDay()];
//   };

// src/admindashboardutils/utils/timeUtils.js
export const parseTimeToSeconds = (timeStr) => {
  if (!timeStr) {
    console.warn("No time string provided, returning 0");
    return 0;
  }

  console.log("Attempting to parse time:", timeStr); // Debug log

  try {
    // Attempt to parse as ISO 8601 string
    const date = new Date(timeStr);
    if (isNaN(date.getTime())) {
      throw new Error("Invalid ISO date-time");
    }
    const hours = date.getUTCHours();
    const minutes = date.getUTCMinutes();
    const seconds = date.getUTCSeconds();
    console.log(`Parsed ISO time: ${hours}:${minutes}:${seconds} (seconds: ${hours * 3600 + minutes * 60 + seconds})`);
    return hours * 3600 + minutes * 60 + seconds;
  } catch (isoError) {
    // Fallback to 12-hour format with AM/PM
    const [time, period] = timeStr.trim().split(" ");
    let [hours, minutes, seconds] = time.split(":").map(Number);

    if (isNaN(hours) || isNaN(minutes) || isNaN(seconds) || !period) {
      console.error("Invalid time format (legacy or ISO fallback failed):", timeStr, isoError);
      return 0;
    }

    if (period.toLowerCase() === "pm" && hours !== 12) hours += 12;
    if (period.toLowerCase() === "am" && hours === 12) hours = 0;

    const totalSeconds = hours * 3600 + minutes * 60 + seconds;
    console.log(`Parsed legacy time: ${hours}:${minutes}:${seconds} ${period} (seconds: ${totalSeconds})`);
    return totalSeconds;
  }
};

export const calculateCallDuration = (startTime, endTime) => {
  if (!startTime || !endTime) {
    console.warn("Missing startTime or endTime, returning 0");
    return 0;
  }

  const startSeconds = parseTimeToSeconds(startTime);
  const endSeconds = parseTimeToSeconds(endTime);
  console.log(`Calculating duration: start=${startSeconds}s, end=${endSeconds}s`);

  let duration = endSeconds - startSeconds;
  if (duration < 0) {
    duration += 24 * 3600; // Add 24 hours if endTime is on the next day
    console.warn("Negative duration adjusted by 24 hours:", duration);
  } else if (duration > 24 * 3600) {
    console.warn("Duration exceeds 24 hours, clamping to 24 hours:", duration);
    duration = 24 * 3600;
  }

  console.log("Calculated duration:", duration);
  return duration;
};

export const isToday = (dateStr) => {
  if (!dateStr) {
    console.warn("Missing createdAt field for call, skipping...");
    return false;
  }
  const callDate = new Date(dateStr);
  const today = new Date();
  return (
    callDate.getDate() === today.getDate() &&
    callDate.getMonth() === today.getMonth() &&
    callDate.getFullYear() === today.getFullYear()
  );
};

export const getFullDayName = (date) => {
  const days = ["Sun", "Mon", "Tue", "Wed", "Thurs", "Fri", "Sat"];
  return days[date.getDay()];
};